import { request } from './http.js'

export async function fetchImportStatus() {
  return request('/api/import/status')
}

export async function syncCsvToDb({ force = false } = {}) {
  return request('/api/import/sync', {
    method: 'POST',
    body: JSON.stringify({ force }),
  })
}
